
import BreadcrumbView from "../common/breadcrumb/breadcrumb.html";
import AuthenticationProcessesListView from "./authentication_processes-list.html";
import AuthenticationProcessesEditView from "./authentication_processes-edit.html";

angular.module('authentication_processes', ['ui.bootstrap.contextMenu'])

    .config(['$stateProvider', function ($stateProvider) {
        $stateProvider
            .state('authentication_processes', {
                url: "/authentication_processes",
                abstract: true,
                controller: "BreadcrumbCtrl",
                template: BreadcrumbView,
            })

            .state('authentication_processes.list', {
                url: "/list",
                controller: "authenticationProcessesListCtrl",
                template: AuthenticationProcessesListView,
                // requiredPermission: ["AUTHENTICATION_SERVICES_READ"]
            })

            .state('authentication_processes.edit', {
                url: "/edit/:id",
                controller: "authenticationProcessesEditCtrl",
                template: AuthenticationProcessesEditView,
                data: { pageTitle: "Servicio" },
               //  requiredPermission: ["AUTHENTICATION_SERVICES_WRITE"]
            })

    }])
    ;